import React, { ReactElement } from 'react';
import { Answer, QuestionSpec, StringArrayQuestionSpec, Nullable, ButtonsSettings } from '../../../types/types';
import QuestionBox from "../box";
import QuestionValue from "../value";
import StringArrayFieldViewer from '../../field/viewers/stringarrayfieldviewer';
import QuestionLabel from '../label';
import QuestionEditorButton from '../questioneditorbutton';

function StringArrayQuestionViewer(props: {spec: QuestionSpec, answer: Nullable<Answer>, setAnswer?: (answer: Nullable<Answer>) => void, buttonsSettings?: ButtonsSettings, disableInput?: string}): ReactElement {
  const stringArrayQuestionSpec = props.spec as StringArrayQuestionSpec;
  const setValue = (value: Nullable<Answer['value']>) => {
    if (props.answer && props.setAnswer) {
      props.setAnswer({
        ...props.answer,
        value
      });
    }
  };
  
  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <StringArrayFieldViewer spec={stringArrayQuestionSpec} answer={props.answer} />
      </QuestionValue>
      {props.setAnswer && props.buttonsSettings &&
        <QuestionEditorButton response={props.answer?.value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} previousAnswer />
      }
    </QuestionBox>
  );
}

export default StringArrayQuestionViewer;
